import { getRouteApi, useParams } from '@tanstack/react-router'
import { useLoginDetail } from '@/queries.ts'
import { UserOrg } from '@/models/user.tsx'
import { type IPublicClientApplication } from '@azure/msal-browser'

const rootRoute = getRouteApi('__root__')

// useCurrentOrg() should only be used when a LEA-specific context is not guaranteed.
// Where possible, use: const currentUserOrg = useRouteContext({ from: '/$leaid' }).currentUserOrg;
export function useCurrentOrg(): UserOrg | undefined {
    const params = useParams({ strict: false })
    const loginDetail = useLoginDetail()
    return loginDetail.userOrgs.find(x => x.esiIdPath == params.leaid)
}

export function logout(instance: IPublicClientApplication, homeAccountId: string) {
    console.log("Logging out user with accountId:", homeAccountId);
    const account = instance.getAccountByHomeId(homeAccountId);
    const logoutRequest = {
        account,
        logoutHint: account?.loginHint,
    };
    localStorage.removeItem("termsConditionsAccepted");
    localStorage.removeItem("timeLastActive");
    instance.logoutRedirect(logoutRequest)
        .catch(error => { console.error(error); });
}
